
import axios from 'axios';
import { navigate } from '../navigation/rootNavigator';


// CRIA A NOVA INSTÂNCIA DO AXIOS
const instance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL, // URL BASE DO SERVIDOR BASEADA NO VALOR DA CLASSE
    withCredentials: true
});


// CONFIGURAÇÃO DOS HEADERS
instance.interceptors.request.use(
    (config) => {
        config.headers['x-api-key'] = process.env.REACT_APP_API_KEY;

        const token = localStorage.getItem('admin_token');
        if(token){
            config.headers['authentication'] = token;
        }

        return config;

    }, (error) => {
        console.error('ERROR - AXIOS CONFIG:', error);
        return Promise.reject(error);
    }
)


// CONFIGURAÇÃO DAS RESPOSTAS DE ERRO
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    
    (error) => {
        if(error?.response?.status == 401 && error?.response?.data == 'INVALID TOKEN'){
            console.error('REQUEST ERROR:', error);
            navigate('logout');
        }

        return Promise.reject(error);   
    }
)

export default instance;